// ABOUTME: Label component built on Radix UI Label primitive
// ABOUTME: Provides consistent label styling with color and disabled states

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"
import type { VariantProps } from "class-variance-authority"
import { cn } from "@shared/lib/utils"
import { labelVariants } from "./CLabel.variants"

export interface CLabelProps
  extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>, VariantProps<typeof labelVariants> {
  value?: string
  color?: "default" | "success" | "failure"
  disabled?: boolean
}

export const CLabel = React.forwardRef<React.ComponentRef<typeof LabelPrimitive.Root>, CLabelProps>(
  ({ className, value, color, disabled, children, ...props }, ref) => {
    const colorClasses = {
      default: "",
      success: "text-green-700",
      failure: "text-red-700",
    }

    return (
      <LabelPrimitive.Root
        ref={ref}
        className={cn(
          labelVariants(),
          color && colorClasses[color],
          disabled && "opacity-50 cursor-not-allowed",
          className,
        )}
        {...props}
      >
        {value || children}
      </LabelPrimitive.Root>
    )
  },
)

CLabel.displayName = "CLabel"
